const EventTabs = () => {
    var tabs   = document.querySelectorAll('.event-agenda__tab');
    var panels = document.querySelectorAll('.event-agenda__panel');

    function activateTab(targetId) {
        tabs.forEach(function (tab) {
            tab.classList.remove('is-active');
            tab.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (panel) {
            panel.classList.remove('is-active');
        });

        var newTab = document.querySelector('[data-target="' + targetId + '"]');
        if (newTab) {
            newTab.classList.add('is-active');
            newTab.setAttribute('aria-selected', 'true');
        }

        var newPanel = document.getElementById(targetId);
        if (newPanel) {
            newPanel.classList.add('is-active');
        }
    }

    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            var targetId = tab.getAttribute('data-target');
            activateTab(targetId);
        });
    });
}

export default EventTabs;